export const validationErrorMessage = (
  error: ValidityState,
  fieldName?: string
) => {
  if (error.tooShort) return `${fieldName ?? "El campo"} es demasiado corto`;
  if (error.tooLong) return `${fieldName ?? "El campo"} es demasiado largo`;
  if (error.patternMismatch)
    return `${fieldName ?? "El campo"} debe tener un formato válido`;
  if (error.valueMissing) return `${fieldName ?? "El campo"} es requerido`;
  if (error.customError) return `${fieldName ?? "El campo"} es invalido`;
  if (error.typeMismatch)
    return `${fieldName ?? "El campo"} debe tener un formato válido`;
  // TODO: This should not happen.
  if ((error as any).customMsg)
    return `${fieldName ?? "El campo"} ${(error as any).customMsg}`;
  return "";
};
